import { ISO_4217 } from "../../iso-4217";
import { event, GtagEvent } from "./event";
import { Item } from "./item";

export interface ViewItemList extends GtagEvent {
    currency?:ISO_4217;
    value?:number
    item_list_id?: string;
    item_list_name?: string;
    items:Item[]
}
/* // マニュアル通りだとこうなるけど例と一致しなくなる
export interface ViewItemList {
    currency:ISO_4217;
    item_list_id?: string;
    item_list_name?: string;
    items:Item[]
}
*/
export const view_item_list = ($_:ViewItemList) => event('view_item_list',$_);